<template>
    <div>
        <h3 class="title is-3">Release Notes</h3>
        <hr />
        <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
        <div class="timeline is-centered">
            <header class="timeline-header">
                <span class="tag is-medium is-primary">Latest</span>
            </header>
            <template v-for="release in releases">
                <div class="timeline-item is-primary" :key="release.id">
                    <div class="timeline-marker is-primary"></div>
                    <div class="timeline-content">
                        <p class="heading">{{release.version}} {{release.detail}}</p>
                        <ul v-for="note in release.notes" :key="note.note">
                            <li style="font-size:12px;">- {{note.note}}</li>
                        </ul>
                    </div>
                </div>
            </template>
            <header class="timeline-header">
                <span class="tag is-medium is-primary">Oldest</span>
            </header>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    releases: [],
    isFullPage: true,
    isLoading: false
  }),
  created() {
    this.getReleaseNotes()
  },
  methods: {
    getReleaseNotes() {
      this.isLoading = true
      axios
        .get(`api/releasenotes`)
        .then(response => {
          this.releases = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
